<template>
	<div>
		<StripePaymentForm @submit="submitPayment" @cancel="currentStep = 3" :email="email" />
	</div>
</template>

<script>
import StripePaymentForm from '@/components/stripe/StripePaymentForm';
import { GiftCardPurchaseDetails } from '@/services/models';

export default {
	name: 'buy-giftcard-payment',
	components: { StripePaymentForm },
	props: {
		giftcard: null,
		value: null, // Current step,
		email: null
	},
	computed: {
		currentStep: {
			get() {
				return this.value || -1;
			},
			set(value) {
				this.$emit('input', value);
			}
		}
	},
	data() {
		return {
			valid: false
		};
	},
	methods: {
		submitPayment(paymentMethodId) {
			if (paymentMethodId && this.giftcard instanceof GiftCardPurchaseDetails) {
				this.$emit(
					'submit',
					new GiftCardPurchaseDetails({
						...this.giftcard,
						paymentMethodId
					})
				);
			}
		}
	}
};
</script>
